/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "us-east-1",
    "aws_appsync_graphqlEndpoint": "https://jmv2ooh6yndcdaa4ejbczufhfa.appsync-api.us-east-1.amazonaws.com/graphql",
    "aws_appsync_region": "us-east-1",
    "aws_appsync_authenticationType": "API_KEY",
    "aws_appsync_apiKey": "da2-6itk5lnyijbk5lrirptrxdcdzi",
    "aws_cognito_identity_pool_id": "us-east-1:c27eaa87-6766-4b94-8ae2-5df6f251f78c",
    "aws_cognito_region": "us-east-1",
    "aws_user_pools_id": "us-east-1_J1NlzTt2s",
    "aws_user_pools_web_client_id": "58h7ihs4n2aajmpciuifhjqi65",
    "oauth": {},
    "aws_cognito_username_attributes": [],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ]
};


export default awsmobile;
